
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.42 20.971v-2.556h2.504v2.556c0 .682-.247 1.278-.741 1.789a2.426 2.426 0 01-1.815.767H3.146c-.681 0-1.278-.256-1.789-.767-.51-.511-.766-1.107-.766-1.789V3.082c0-.715.255-1.32.766-1.814S2.465.527 3.147.527h10.221c.716 0 1.32.247 1.815.74.494.495.74 1.1.74 1.815v3.833H13.42V3.082H3.146v17.889H13.42m10.172-8.331l-5.06 5.009v-3.067H7.03V10.75h11.5V7.682l5.06 4.958"}})])
          )
        }
      }
    